import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Box } from '../Box';
import { SkeletonTable } from './SkeletonTable';
import { SkeletonText } from './SkeletonText';
import { SkeletonAvatar } from './SkeletonAvatar';
import { SkeletonList } from './SkeletonList';
import './Skeleton.css';
const SkeletonComponent = forwardRef(function Skeleton(props, ref) {
    const { elementType = 'div', className, faded, size, inline, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, elementType: elementType, className: clsx('mollie-ui-skeleton', {
            'mollie-ui-skeleton--inline': !!inline,
            'mollie-ui-skeleton--faded': faded === true,
            'mollie-ui-skeleton--faded-light': faded === 'light',
            'mollie-ui-skeleton--faded-heavy': faded === 'heavy',
            [`mollie-ui-skeleton--${size}`]: typeof size === 'string',
        }, className), style: {
            '--mollie-ui-box-max-width': typeof size === 'number' ? `${size}%` : undefined,
        }, ref: ref }));
});
SkeletonComponent.displayName = 'Skeleton';
export const Skeleton = Object.assign({}, SkeletonComponent, {
    Text: SkeletonText,
    Table: SkeletonTable,
    Avatar: SkeletonAvatar,
    List: SkeletonList,
});
//# sourceMappingURL=Skeleton.js.map